<template>
  <div
      :class="{ 'is-open': open }"
      class="lp-fill-section">
    <button
        :aria-expanded="open ? 'true' : 'false'"
        type="button"
        class="lp-fill-section__head"
        @click.stop="$emit('toggle')">
      <svg
          class="lp-fill-section__chevron"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true">
        <path d="M9 6l6 6-6 6"/>
      </svg>
      <span class="lp-fill-section__title">{{ title }}</span>
      <span
          v-if="summaryText || summaryColor"
          class="lp-fill-section__summary">
        <span
            v-if="summaryText"
            class="lp-fill-section__summary-text">{{ summaryText }}</span>
        <span
            v-if="summaryColor"
            :style="{ background: summaryColor }"
            class="lp-fill-section__swatch"/>
      </span>
    </button>
    <div
        v-if="open"
        class="lp-fill-section__body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name:  'FillColorSection',
  props: {
    title:        { type: String, default: 'Fill color' },
    open:         { type: Boolean, default: false },
    summaryText:  { type: String, default: '' },
    summaryColor: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-fill-section {
  margin-top: 16px;
}

.lp-fill-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: $lp-ink;
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: 2px solid $lp-accent;
    outline-offset: 2px;
    border-radius: 4px;
  }
}

.lp-fill-section__chevron {
  flex: 0 0 auto;
  color: $lp-muted;
  transition: transform 0.15s ease;

  .is-open & {
    transform: rotate(90deg);
  }
}

.lp-fill-section__title {
  flex: 1 1 auto;
  font-family: $lp-sans;
  font-size: $lp-fs-control;
  font-weight: 600;
}

.lp-fill-section__summary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.lp-fill-section__summary-text {
  font-family: $lp-mono;
  font-size: $lp-fs-control;
  color: $lp-muted;
}

.lp-fill-section__swatch {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  box-shadow: inset 0 0 0 1px rgba(20, 22, 27, 0.12);
}

.lp-fill-section__body {
  margin-top: 10px;
}
</style>
